<template>
  <div class="page-content not-found">
    <!-- <h1 class="page-title"></h1> -->
    <h2>404 - {{ $locale("global.pageNotFound") }}</h2>
    <p>
      <router-link :to="{ name: 'dashboard' }">
        {{ $locale("global.goToHomePage") }}
      </router-link>
    </p>
  </div>
</template>

<script>
export default {
  name: "NotFound"
};
</script>

<style lang="less" scoped>
.not-found {
  h2,
  p {
    text-align: center;
  }

  h2 {
    margin-top: 30px;
    font-size: 1.4rem;
  }
}
</style>
